import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
export const FlushedTitle = props => {
  return /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
    as: "h5",
    marginBlockEnd: "0"
  }));
};
export const Divider = props => {
  return /*#__PURE__*/_jsx(HR, Object.assign({}, props, {
    inlineSize: "50px",
    marginBlock: "700",
    marginInline: "0"
  }));
};
export const StyledTitleContainer = props => {
  return /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
    as: "span",
    marginBlockEnd: "200"
  }));
};